require('re-tree');
require('./ng-device-detector');
module.exports = 'ng.deviceDetector';


//////////////////
// WEBPACK FOOTER
// ./~/ng-device-detector/index.js
// module id = 295
// module chunks = 1